"use client";

import React, { useMemo, useState } from "react";
import { Modal, Rate, message } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import "./FeedbackPopup.css";

import { useFeedback } from "../../../AdminDashboard/hooks/useFeedback";

export default function FeedbackPopup({
  open,
  onClose,
  user,
  // onSubmitFeedback,
}) {
  const { t } = useTranslation();

  const { addFeedback } = useFeedback();

  const [rating, setRating] = useState(0);
  // const [category, setCategory] = useState("general");
  const [feedback, setFeedback] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const userName = useMemo(() => {
    return (
      user?.fullName ||
      user?.name ||
      `${user?.firstName || ""} ${user?.lastName || ""}`.trim() ||
      "User"
    );
  }, [user]);

  const avatarSrc =
    user?.avatar ||
    user?.avatarUrl ||
    user?.photo ||
    user?.photoUrl ||
    user?.profilePictureUrl ||
    "";

  const categories = [
    {
      value: "general",
      label: t("feedbackPopup.categories.general", {
        defaultValue: "General feedback",
      }),
    },
    {
      value: "bug",
      label: t("feedbackPopup.categories.bug", {
        defaultValue: "Bug / technical issue",
      }),
    },
    {
      value: "improvement",
      label: t("feedbackPopup.categories.improvement", {
        defaultValue: "Improvement idea",
      }),
    },
    {
      value: "reclamation",
      label: t("feedbackPopup.categories.reclamation", {
        defaultValue: "Reclamation",
      }),
    },
  ];
const resetForm = () => {
  setRating(0);
  setFeedback("");
  setSubmitting(false);
};

  const handleClose = () => {
    resetForm();
    onClose?.();
  };


  const handleSubmit = async () => {
  if (!rating) {
    message.warning(
      t("feedbackPopup.validation.rating", {
        defaultValue: "Please choose a rating.",
      })
    );
    return;
  }

  if (!feedback.trim()) {
    message.warning(
      t("feedbackPopup.validation.message", {
        defaultValue: "Please write your feedback.",
      })
    );
    return;
  }

  try {
    setSubmitting(true);

    await addFeedback({
      rating,
      message: feedback.trim(),
    });

    message.success(
      t("feedbackPopup.success", {
        defaultValue:
          "Feedback sent successfully. Thank you for sharing your feedback!",
      }),
      2
);

setTimeout(() => {
  handleClose();
}, 5000);

    handleClose();
  } catch (error) {
    console.error("[FeedbackPopup] submit error:", error);
    message.error(
      t("feedbackPopup.error", {
        defaultValue: "Could not send feedback. Please try again.",
      })
    );
  } finally {
    setSubmitting(false);
  }
};

  // const handleSubmit = async () => {
  //   if (!rating) {
  //     message.warning(
  //       t("feedbackPopup.validation.rating", {
  //         defaultValue: "Please choose a rating.",
  //       })
  //     );
  //     return;
  //   }

  //   if (!feedback.trim()) {
  //     message.warning(
  //       t("feedbackPopup.validation.message", {
  //         defaultValue: "Please write your feedback.",
  //       })
  //     );
  //     return;
  //   }

  //   const payload = {
  //     rating,
  //     category,
  //     message: feedback.trim(),
  //     userId: user?.id || user?._id || user?.userId || null,
  //     userName,
  //     createdAt: new Date().toISOString(),
  //   };

  //   try {
  //     setSubmitting(true);

  //     if (typeof onSubmitFeedback === "function") {
  //       await onSubmitFeedback(payload);
  //     } else {
  //     }

  //     message.success(
  //       t("feedbackPopup.success", {
  //         defaultValue: "Thank you for your feedback!",
  //       })
  //     );

  //     handleClose();
  //   } catch (error) {
  //     console.error("[FeedbackPopup] submit error:", error);
  //     message.error(
  //       t("feedbackPopup.error", {
  //         defaultValue: "Could not send feedback. Please try again.",
  //       })
  //     );
  //   } finally {
  //     setSubmitting(false);
  //   }
  // };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={null}
      centered
      width={540}
      closeIcon={<CloseOutlined />}
      className="feedback-popup-modal"
      destroyOnClose
    >
      <div className="feedback-popup">
        <div className="feedback-popup__header">
          <div className="feedback-popup__title-block">

            <h2 className="feedback-popup__title">
              {t("feedbackPopup.title", {
                defaultValue: "Feedback & reclamations",
              })}
            </h2>

            <p className="feedback-popup__subtitle">
              {t("feedbackPopup.subtitle", {
                defaultValue:
                  "Tell us about your experience so we can improve MediLink.",
              })}
            </p>
          </div>
        </div>



        <div className="feedback-popup__field">
          <label className="feedback-popup__label">
            {t("feedbackPopup.ratingLabel", {
              defaultValue: "How would you rate your experience?",
            })}
          </label>

          <div className="feedback-popup__rate-row">
            <Rate value={rating} onChange={setRating} />
            <span className="feedback-popup__rate-value">
              {rating ? `${rating}/5` : "0/5"}
            </span>
          </div>
        </div>

        <div className="feedback-popup__field">
          <label className="feedback-popup__label">
            {t("feedbackPopup.messageLabel", {
              defaultValue: "Your message",
            })}
          </label>

          <textarea
            className="feedback-popup__textarea"
            rows={5}
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            placeholder={t("feedbackPopup.placeholder", {
              defaultValue: "Write your feedback or reclamation here...",
            })}
            maxLength={800}
          />

          <div className="feedback-popup__counter">{feedback.length}/800</div>
        </div>

        <div className="feedback-popup__actions">
          <button
            type="button"
            className="feedback-popup__btn feedback-popup__btn--cancel"
            onClick={handleClose}
            disabled={submitting}
          >
            {t("feedbackPopup.cancel", {
              defaultValue: "Cancel",
            })}
          </button>

          <button
            type="button"
            className="feedback-popup__btn feedback-popup__btn--submit"
            onClick={handleSubmit}
            disabled={submitting}
          >
            {submitting
              ? t("feedbackPopup.sending", {
                  defaultValue: "Sending...",
                })
              : t("feedbackPopup.submit", {
                  defaultValue: "Send feedback",
                })}
          </button>
        </div>
      </div>
    </Modal>
  );
}
